<template>
    <div id="webcam">
        <div>
              <!-- Selecció càmara -->
              <div class="p-4 mb-2">
                  <div class="form-group">
                    <label class="mb-2">{{ $t('tabs.photo.select_webcam') }}:</label>
                    <select v-model="camera" class="form-control select-camera">
                        <option value="">-- {{ $t('tabs.photo.select_webcam') }} --</option>
                        <option v-for="device in devices"
                                :key="device.deviceId"
                                :value="device.deviceId">{{ device.label }}</option>
                    </select>
                </div>
              </div>
              <!-- End Selecció càmara -->
              <div v-if="!edit">
                  <!-- Camera -->
                  <div class="border-camera">
                    <vue-web-cam ref="webcam"
                                 :device-id="deviceId"
                                 width="100%"
                                 @started="onStarted"
                                 @stopped="onStopped"
                                 @error="onError"
                                 @cameras="onCameras"
                                 @camera-change="onCameraChange" />
                  </div>
                  <!-- End Camera -->
                  <!-- Camera Button -->
                  <div class="text-center p-2">
                    <button type="button"
                            class="btn btn-warning btn-xl btn-block u-btn-outline-black g-m-5"
                            @click="onCapture"><i class="fa fa-camera"></i> {{ $t('tabs.photo.take_snapshot') }}</button>
                  </div>
                  <!-- End Camera Button -->
              </div>
            <div>
                <div class="avatar-edit" v-show="img && edit">
                <div class="avatar-edit-image" v-if="img">
                  <img ref="editImage" :src="img" class="cropper-hidden"/>
                </div>
                <div class="text-center p-4">
                  <button type="submit" class="btn btn-warning" @click.prevent="cropImage"><i class="fas fa-crop"></i> {{ $t('tabs.photo.crop_photo')}}</button>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Cropper from 'cropperjs'
    import 'cropperjs/dist/cropper.min.css'
    import 'cropperjs/dist/cropper'
    import { WebCam } from "vue-web-cam";

    export default {
        name: "web-cam",
        components: {
            "vue-web-cam": WebCam
        },
        data() {
            return {
                img: null,
                edit: false,
                camera: null,
                cropper: false,
                deviceId: null,
                devices: []
            };
        },
        computed: {
              device: function() {
                  return this.devices.find(n => n.deviceId === this.deviceId);
              }
          },
          watch: {
              camera: function(id) {
                  this.deviceId = id;
              },
              devices: function() {
                  // Once we have a list select the first one
                const first = this.devices[0];
                  if (first) {
                      this.camera = first.deviceId;
                      this.deviceId = first.deviceId;
                  }
              },
              edit(value) {
                if (value) {
                  this.$nextTick(function () {
                    if (!this.$refs.editImage) {
                      return;
                    }

                    this.cropper = new Cropper(this.$refs.editImage, {
                      minContainerWidth: 420,
                      minContainerHeight: 340,
                      minCanvasWidth: 420,
                      minCanvasHeight: 240,
                      minCropBoxWidth: 150,
                      minCropBoxHeight: 190,
                      cropBoxResizable: true,
                      movable: true,
                      dragMode: 'move',
                      viewMode: 1,
                      initialAspectRatio: 1 / 2,
                      aspectRatio: 12 / 16,
                      autoCropArea: 1,
                    })
                  })
                } else {
                  if (this.cropper) {
                    this.cropper.destroy()
                    this.cropper = false
                  }
                }
              }
          },
          methods: {
              onCapture() {
                  this.img = this.$refs.webcam.capture();
                  this.edit = true;
              },
              onStarted(stream) {
                  console.log("On Started Event", stream);
              },
              onStopped(stream) {
                  console.log("On Stopped Event", stream);
              },
              onStop() {
                  this.$refs.webcam.stop();
              },
              onStart() {
                  this.$refs.webcam.start();
              },
              onError(error) {
                  console.log("On Error Event", error);
              },
              onCameras(cameras) {
                  this.devices = cameras;
                  console.log("On Cameras Event", cameras);
              },
              onCameraChange(deviceId) {
                  this.deviceId = deviceId;
                  this.camera = deviceId;
                  console.log("On Camera Change Event", deviceId);
              },
              cropImage() {
                this.edit = false
                let oldFile = this.img
                let binStr = atob(this.cropper.getCroppedCanvas({
                  imageSmoothingQuality: 'high'
                }).toDataURL(oldFile.type).split(',')[1])
                let arr = new Uint8Array(binStr.length)
                for (let i = 0; i < binStr.length; i++) {
                  arr[i] = binStr.charCodeAt(i)
                }
                let file = new File([arr], oldFile.name, { type: oldFile.type })
                this.$emit('takedPhoto', file);
              },
          }
    };
</script>

<style>
    .border-camera{
        width: 100%;
    }

    .select-camera {
      color: #333 !important;
    }
</style>
